"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");
const styled_components_1 = __importStar(require("styled-components"));
const Spinner = styled_components_1.default.div `
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;

  & > div {
    transform-origin: 32px 32px;
    animation: spinner 1.2s linear infinite;
  }
  & > div:after {
    content: " ";
    display: block;
    position: absolute;
    top: 3px;
    left: 29px;
    width: 5px;
    height: 14px;
    border-radius: 20%;
    background-color: ${bitcoincom_pkg_theme_1.colors.solid.primaryBlue};
  }
  & > div:nth-child(1) {
    transform: rotate(0deg);
    animation-delay: -1.1s;
  }
  & > div:nth-child(2) {
    transform: rotate(30deg);
    animation-delay: -1s;
  }
  & > div:nth-child(3) {
    transform: rotate(60deg);
    animation-delay: -0.9s;
  }
  & > div:nth-child(4) {
    transform: rotate(90deg);
    animation-delay: -0.8s;
  }
  & > div:nth-child(5) {
    transform: rotate(120deg);
    animation-delay: -0.7s;
  }
  & > div:nth-child(6) {
    transform: rotate(150deg);
    animation-delay: -0.6s;
  }
  & > div:nth-child(7) {
    transform: rotate(180deg);
    animation-delay: -0.5s;
  }
  & > div:nth-child(8) {
    transform: rotate(210deg);
    animation-delay: -0.4s;
  }
  & > div:nth-child(9) {
    transform: rotate(240deg);
    animation-delay: -0.3s;
  }
  & > div:nth-child(10) {
    transform: rotate(270deg);
    animation-delay: -0.2s;
  }
  & > div:nth-child(11) {
    transform: rotate(300deg);
    animation-delay: -0.1s;
  }
  & > div:nth-child(12) {
    transform: rotate(330deg);
    animation-delay: 0s;
  }
  @keyframes spinner {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;
const pulse = (0, styled_components_1.keyframes) `
  0%, 50%, 100% {
    transform: scaleY(0.2);
  }  25% {
    transform: scaleY(0.5);
  }
`;
const BarsMain = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
`;
const Rectangle = styled_components_1.default.div `
  background-color: ${bitcoincom_pkg_theme_1.colors.solid.primaryBlue};
  height: 100%;
  width: 20%;
  display: inline-block;
  animation: ${pulse} 1.5s infinite ease-in-out;
  animation-delay: ${(props) => (props.delay ? props.delay : 0)}s;
`;
const Bars = ({ width, height }) => (react_1.default.createElement(BarsMain, { width: width, height: height },
    react_1.default.createElement(Rectangle, { delay: 0 }),
    react_1.default.createElement(Rectangle, { delay: 0.1 }),
    react_1.default.createElement(Rectangle, { delay: 0.2 }),
    react_1.default.createElement(Rectangle, { delay: 0.3 }),
    react_1.default.createElement(Rectangle, { delay: 0.4 })));
/**
 * Loader component
 */
const Loader = (_a) => {
    var { type = "spinner", height = "50px", width = "150px" } = _a, rest = __rest(_a, ["type", "height", "width"]);
    if (type === "bars")
        return react_1.default.createElement(Bars, Object.assign({ height: height, width: width }, rest));
    return (react_1.default.createElement(Spinner, Object.assign({}, rest),
        react_1.default.createElement("div", null),
        react_1.default.createElement("div", null),
        react_1.default.createElement("div", null),
        react_1.default.createElement("div", null),
        react_1.default.createElement("div", null),
        react_1.default.createElement("div", null),
        react_1.default.createElement("div", null),
        react_1.default.createElement("div", null),
        react_1.default.createElement("div", null),
        react_1.default.createElement("div", null),
        react_1.default.createElement("div", null),
        react_1.default.createElement("div", null)));
};
exports.default = Loader;
//# sourceMappingURL=Loader.js.map